import { Fragment, useEffect, useRef } from "react"
import { ScheduleState, SelectedSession, UserResponse } from "../../../Common"
import { Label } from "@progress/kendo-react-labels"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarCheck, faCircleMinus, faDiagramNested, faCalendarMinus, faCircleCheck, faCircleExclamation, faHand, faExclamation, faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { useGlobalCtx } from "../../../Context/GlobalContext"
import { SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_SEPostSurveyScheduleOperation, SurveyEngine_Models_SESurveyConfirmOperation, SurveyEngine_Models_StudyType } from "../../../api"
import { Button } from "@progress/kendo-react-buttons"
import { useRecruitCtx, useRecruitDispatchCtx } from "../../../Context/RecruitContext"
import { useSurveyCtx, useSurveyCtxDispatch } from "../../../Context/SurveyContext"

interface RecruitConfirmationProps {
    id:number,
    studyName: string,
    selectedSessions: Array<SelectedSession>
    studyType: SurveyEngine_Models_StudyType
    confirmEnabled: boolean
    cancelEnabled : boolean
    rescheduleEnabled: boolean
    getNextQuestionCommand?: (surveySID: string, payLoad: UserResponse, isFirstTime?: boolean) => void
    getSubmitSchedule?: (panelistId: number, StudyId: number, operationType: SurveyEngine_Models_SEPostSurveyScheduleOperation, payload: number[]) => void
    getSubmitPendingConfirmation?:(surveySID:string,payLoad:SurveyEngine_Models_RecruitResponse,operation:SurveyEngine_Models_SESurveyConfirmOperation) => void
}

export const RecruitConfirmation = (props: RecruitConfirmationProps) => {

    const globalCtx = useGlobalCtx();
    const surveyCtx = useSurveyCtx();
    const recruitCtx = useRecruitCtx();
    const surveyCtxDispatch = useSurveyCtxDispatch()
    const recruitCtxDispatch = useRecruitDispatchCtx()
    const buttonRef = useRef<Button>(null);
    const confirmRef = useRef<HTMLDivElement>(null);

    let confirmLabels = "confirmHeading ConfirmMsg ConfirmStudyName"
    let heading: string = "";
    let message: string = "";
    let headingIcon = <FontAwesomeIcon icon={faCalendarCheck} />;
    let messageIcon = <FontAwesomeIcon icon={faCircleExclamation} />;
    let sessionIcon = <FontAwesomeIcon icon={faCircleCheck} />;;

    switch (recruitCtx.currentState) {
        case ScheduleState.CONFIRM:
        case ScheduleState.POST_SURVEY_CONFIRM:
        case ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM:
            heading = globalCtx.LangResources.recruitMsg.confirmation.heading;
            message = globalCtx.LangResources.recruitMsg.confirmation.message.replace("{StudyName}", props.studyName);
            headingIcon = <FontAwesomeIcon icon={faCalendarCheck} className="theme-session-header-icon " />;
            messageIcon = <FontAwesomeIcon icon={faCircleExclamation} className="theme-validator-success-icon theme-icon-spacer" />;
            sessionIcon = <FontAwesomeIcon className="theme-validator-success-icon theme-icon-spacer" icon={faCircleCheck} />
            break;
        case ScheduleState.POST_SURVEY_CANCEL:
            heading = globalCtx.LangResources.recruitMsg.cancel.heading;
            message = globalCtx.LangResources.recruitMsg.cancel.message.replace("{StudyName}", props.studyName);
            headingIcon = <FontAwesomeIcon icon={faCalendarMinus} className="theme-session-header-icon" />;
            messageIcon = <FontAwesomeIcon icon={faCircleExclamation} className="theme-validator-error-icon theme-icon-spacer" />;
            sessionIcon = <FontAwesomeIcon className="theme-validator-error-icon theme-icon-spacer" icon={faCircleMinus} />
            break;
        case ScheduleState.POST_SURVEY_SCHEDULED:
            heading = globalCtx.LangResources.recruitMsg.scheduled.heading;
            message = globalCtx.LangResources.recruitMsg.scheduled.message.replace("{StudyName}", props.studyName);
            headingIcon = <FontAwesomeIcon icon={faCalendarCheck} className="theme-session-header-icon" />;
            messageIcon = <FontAwesomeIcon icon={faCircleInfo} className="theme-validator-success-icon theme-icon-spacer" />;
            sessionIcon = <FontAwesomeIcon className="theme-validator-success-icon theme-icon-spacer" icon={faCircleCheck} />
            break;
    }

    useEffect(() => {

        if (recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCEL || recruitCtx.currentState === ScheduleState.POST_SURVEY_SCHEDULED) {
            confirmRef.current?.focus();
        }
        else {
            buttonRef.current?.element?.focus();
        }
    }, [props, recruitCtx.currentState])

    const onRecruitSchedule = () => {
        let sessionIDS: number[] = props.selectedSessions.map((sesion: SelectedSession) => {
            return sesion.sessionId;
        })
        let recruitResponse: SurveyEngine_Models_RecruitResponse = {
            commandIndex: surveyCtx.NextQuestion.commandIndex,
            commandType: surveyCtx.NextQuestion.commandType,
            declined: false,
            eventUrl: "",
            inviteeUrl: "",
            sessionIds: sessionIDS ?? []
        }
        if (props.getNextQuestionCommand)
            props.getNextQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!, [recruitResponse]);
    }
    const onBack = () => {

        if (recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM) {
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_RESCHEDULE });
        }
        else {
            var res:SurveyEngine_Models_RecruitResponse = {
                commandIndex:props.id,
                commandType:"Recruit",
                declined:false,
                eventUrl:"",
                inviteeUrl:"",
                sessionIds:[]
              }
              if(props.getSubmitPendingConfirmation)
              {
                props.getSubmitPendingConfirmation(surveyCtx.StartSurvey.surveyInstanceId!,res,SurveyEngine_Models_SESurveyConfirmOperation.REMOVE_FROM_ALL_SESSIONS);
                //recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.SCHEDULE });
              }
              else{
                console.log("getSubmitPendingConfirmation is null");
              }  
        }
    }
    const onPostSurveyConfirm = () => {
        if (props.getSubmitSchedule) {
            let isStanBy:boolean = false;
            let sessionIDS: number[] = props.selectedSessions.map((sesion: SelectedSession) => {
                if(sesion.isOverFlow)
                {
                    isStanBy = true;
                }
                return sesion.sessionId;
            })
            if (recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM) {
                props.getSubmitSchedule(globalCtx.PanelistId!, globalCtx.StudyId!,
                            isStanBy?SurveyEngine_Models_SEPostSurveyScheduleOperation.RESCHEDULE_OVERFLOW:SurveyEngine_Models_SEPostSurveyScheduleOperation.RESCHEDULE,
                            sessionIDS)
            }
            else {
                props.getSubmitSchedule(globalCtx.PanelistId!, globalCtx.StudyId!, SurveyEngine_Models_SEPostSurveyScheduleOperation.CONFIRM, sessionIDS)
            }
        }
    }
    const onCancel = () => {

        if (recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCEL) {
            //already on cancel page confirm cancel
            if (props.getSubmitSchedule) {
                let sessionIDS: number[] = props.selectedSessions.map((sesion: SelectedSession) => {
                    return sesion.sessionId;
                })
                props.getSubmitSchedule(globalCtx.PanelistId!, globalCtx.StudyId!, SurveyEngine_Models_SEPostSurveyScheduleOperation.CANCEL, sessionIDS)
            }
        }
        else {
            surveyCtxDispatch({ type: "setLoading", value: true });
            recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_CANCEL });
            setTimeout(() => {
                surveyCtxDispatch({ type: "setLoading", value: false });
            }, 800);
        }


    }
    const onSkip = () => {
        surveyCtxDispatch({ type: "setLoading", value: true });
        //window.open(surveyCtx.RedirectUrl, '_parent')
        window.location.href = surveyCtx.RedirectUrl;
    }

    const onReschedule = () => {
        recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.POST_SURVEY_RESCHEDULE });
    }
    const GetScheduleRestrictionMsg = () =>{

        if(!props.cancelEnabled && !props.rescheduleEnabled)
        {
            return  <div id="restrictions" className="text-sm italic">
                        <FontAwesomeIcon className="theme-validator-warning-icon theme-icon-spacer" icon={faCircleInfo} />
                        <span className="theme-validator-warning-text">{globalCtx.LangResources.recruitMsg.scheduleRestrictionMsg.replace('{operations}',`${globalCtx.LangResources.recruitMsg.cancelButton} or ${globalCtx.LangResources.recruitMsg.rescheduleButton}`)}</span>
                    </div>; 
        }
        else if(!props.cancelEnabled && props.rescheduleEnabled)
        {
            return  <div id="restrictions" className="text-sm italic">
            <FontAwesomeIcon className="theme-validator-warning-icon theme-icon-spacer" icon={faCircleInfo} />
            <span className="theme-validator-warning-text">{globalCtx.LangResources.recruitMsg.scheduleRestrictionMsg.replace('{operations}',`${globalCtx.LangResources.recruitMsg.cancelButton}`)}</span>
            </div>; 
 
        }
        else if(props.cancelEnabled && !props.rescheduleEnabled)
        {
            return  <div id="restrictions" className="text-sm italic">
            <FontAwesomeIcon className="theme-validator-warning-icon theme-icon-spacer" icon={faCircleInfo} />
            <span className="theme-validator-warning-text">{globalCtx.LangResources.recruitMsg.scheduleRestrictionMsg.replace('{operations}',`${globalCtx.LangResources.recruitMsg.rescheduleButton}`)}</span>
            </div>; 

        }
        else
        {
            return <></>
        }

    }



    return (
        <div>
            <div tabIndex={0} ref={confirmRef} className="theme-session w-full">

                <div className="flex flex-col mb-4">
                    <div id="confirmHeading" className="theme-session-header w-full block">
                        {headingIcon}
                        <span className="theme-session-header-text ml-2 text-3xl font-regular">{heading}</span>
                    </div>
                </div>
                <div className="flex flex-col mb-10">
                    <div id="ConfirmMsg" className="font-semibold">{messageIcon}
                        {message}
                    </div>
                </div>
                <div className="flex flex-col mb-4 ">
                    <div className="theme-session-subheader">
                        <h2 id="ConfirmStudyName" className="text-lg font-semibold mb-4">{globalCtx.LangResources.recruitMsg.studyMsg.replace('{StudyName}', props.studyName)}</h2>
                    </div>
                </div>
                <div className="flex flex-col mb-4">
                    {
                        props.selectedSessions.map((selectedSession: SelectedSession, index: number) => {
                            let sessionlabel = `Session${index}`
                            let standbyMsgLabel = `standbyMsg${index}`
                            let subsessionMsgLabel = `subSessionMsg${index}`
                            confirmLabels = `${confirmLabels} ${sessionlabel} ${standbyMsgLabel}`
                            return (
                                <Fragment key={index}>
                                    {selectedSession.isOverFlow &&
                                        <div className="pb-4">
                                            <div id={standbyMsgLabel} className="theme-validator-warning text-sm font-semibold text-center px-4 py-2 w-full">
                                                <FontAwesomeIcon className="theme-validator-warning-icon theme-icon-spacer" icon={faHand} />
                                                <span className="theme-validator-warning-text">{globalCtx.LangResources.recruitMsg.confirmation.standByConfirmMsg}</span>
                                            </div>
                                        </div>
                                    }
                                    <div className="theme-session-confirm-row">
                                        <div className="flex flex-col py-4">
                                            <div id={sessionlabel} className="flex flex-row xl:justify-between flex-wrap ">
                                                <div className="xl:basis-1/3 sm:basis-1/2 basis-full text-sm font-bold whitespace-nowrap">
                                                    {sessionIcon}
                                                    {selectedSession.sessionDay}
                                                </div>
                                                <div className="xl:basis-1/3 sm:basis-1/2 basis-full text-sm font-semibold pl-5 xl:text-center md:text-end text-start whitespace-nowrap">
                                                    {selectedSession.sessionStartTime} to {selectedSession.sessionEndTime}
                                                </div>
                                                <div className="xl:basis-1/3 basis-full text-sm pl-5 xl:pl-0 font-semibold xl:text-end text-start">
                                                    {selectedSession.sessionName}
                                                </div>
                                            </div>

                                        </div>
                                        {selectedSession.subSession && selectedSession.subSession.length > 0 &&
                                            <div className="pb-4 w-full">
                                                <div id={subsessionMsgLabel} className="theme-session-subsession pl-10 pb-2 flex flex-full">
                                                    <FontAwesomeIcon className="theme-session-subsession-icon theme-icon-spacer" icon={faDiagramNested} />
                                                    <span className="theme-session-subsession-text text-sm pt-[3px] font-semibold">{recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCEL ?
                                                        globalCtx.LangResources.recruitMsg.subSessionCancelMessage : globalCtx.LangResources.recruitMsg.subSessionMessage}</span>
                                                </div>
                                                <div>
                                                    {
                                                        selectedSession?.subSession?.map((subsession: SelectedSession, sindex: number) => {
                                                            let subSessionlabel = `subSession${index}_${sindex}`
                                                            if (sindex === 0)
                                                                confirmLabels = `${confirmLabels} ${subsessionMsgLabel} ${subSessionlabel}`
                                                            else
                                                                confirmLabels = `${confirmLabels} ${subSessionlabel}`
                                                            return (
                                                                <div key={sindex}>
                                                                    <div id={subSessionlabel} className="pl-10 flex md:flex-row flex-col justify-between flex-wrap py-4 border-b-2 border-dotted">
                                                                        <span className="md:basis-1/2 text-sm font-bold whitespace-nowrap">
                                                                            {sessionIcon}
                                                                            {subsession.sessionDay}
                                                                        </span>
                                                                        <div className="md:basis-1/2 text-sm font-semibold pl-4 md:pl-0 whitespace-nowrap">
                                                                            {subsession.sessionStartTime} to {subsession.sessionEndTime}
                                                                        </div>
                                                                    </div>
                                                                </div>);

                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </Fragment>)
                        })
                    }
                </div>
            </div>
            {/* Survey Confirm */}
            {recruitCtx.currentState === ScheduleState.CONFIRM &&
                <div className={'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'}>
                    <div className="mb-8 md:basis-1 lg:basis-1/4">
                        <div className="flex flex-col">
                            <Button
                                id="scheduleButton"
                                ref={buttonRef}
                                className="theme-btn-schedule w-full"
                                data-testid="schedule-btn"
                                onClick={onRecruitSchedule}
                                aria-labelledby={`${confirmLabels} scheduleButton`}
                            >
                                {globalCtx.LangResources.recruitMsg.scheduleButton}
                            </Button>
                            <Label id="scheduleMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.scheduleButtonMsg}</Label>
                        </div>
                    </div>
                    <div className="md:basis-1 lg:basis-1/4">
                        <div className="flex flex-col">
                            <Button
                                id="backButton"
                                className="theme-btn-previous w-full"
                                data-testid="back-button"
                                onClick={onBack}
                                aria-labelledby="backMsg backButton"
                            >{globalCtx.LangResources.recruitMsg.backButton ?? "Back"}</Button>
                            <div id="backMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.backButtonMsg}</div>
                        </div>
                    </div>
                </div>
            }
            {/* PostSurvey Currently Schedule Not Confirm */}
            {recruitCtx.currentState === ScheduleState.POST_SURVEY_CONFIRM &&
                <div className={'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-center pt-8 pb-2 mt-8'}>
                    {props.confirmEnabled && <div className="mb-8 md:basis-1 md:px-1 lg:basis-1/4 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="confirmButton"
                                ref={buttonRef}
                                className="theme-btn-confirm w-full"
                                data-testid="confirm-btn"
                                disabled={!props.confirmEnabled}
                                onClick={onPostSurveyConfirm}
                                aria-labelledby={`${confirmLabels} confirmButton`}
                            >
                                {globalCtx.LangResources.recruitMsg.confirmButton}
                            </Button>
                            <Label id="confirmMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.confirmButtonMsg}</Label>
                        </div>
                    </div>}
                    {props.cancelEnabled && <div className="md:basis-1 md:px-1 lg:basis-1/4 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="cancelButton"
                                className="theme-btn-cancel w-full"
                                data-testid="cancel-button"
                                onClick={onCancel}
                                disabled={!props.cancelEnabled}
                                aria-labelledby="cancelMsg cancelButton"
                            >{globalCtx.LangResources.recruitMsg.cancelButton ?? "Cancel"}</Button>
                            <div id="cancelMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.cancelButtonMsg}</div>
                        </div>
                    </div>}
                    {props.rescheduleEnabled && <div className="md:basis-1 md:px-1 lg:basis-1/4 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="rescheduleButton"
                                className="theme-btn-reschedule w-full"
                                data-testid="reschedule-button"
                                onClick={onReschedule}
                                disabled={!props.rescheduleEnabled}
                                aria-labelledby="rescheduleMsg rescheduleButton"
                            >{globalCtx.LangResources.recruitMsg.rescheduleButton ?? "Reschedule"}</Button>
                            <div id="rescheduleMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.rescheduleButtonMsg}</div>
                        </div>
                    </div>}
                    {(props.cancelEnabled || props.rescheduleEnabled || props.confirmEnabled) && <div className="md:basis-1 md:px-1 lg:basis-1/4 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="skipButton"
                                className="theme-btn-skip w-full"
                                data-testid="skip-button"
                                onClick={onSkip}
                                aria-labelledby="skipMsg skipButton"
                            >{globalCtx.LangResources.recruitMsg.skipButton ?? "Skip"}</Button>
                            <div id="skipMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.skipButtonMsg}</div>
                        </div>
                    </div>}
                </div>
            }
            {/* PostSurvey Currently Scheduled */}
            {(recruitCtx.currentState === ScheduleState.POST_SURVEY_SCHEDULED) &&
                <div className={'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'}>
                    {props.cancelEnabled && <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="cancelButton"
                                className="theme-btn-cancel w-full"
                                data-testid="cancel-button"
                                onClick={onCancel}
                                disabled={!props.cancelEnabled}
                                aria-labelledby="cancelMsg cancelButton"
                            >{globalCtx.LangResources.recruitMsg.cancelButton ?? "Cancel"}</Button>
                            <div id="cancelMsg" className="text-center text-sm pb-2">{globalCtx.LangResources.recruitMsg.cancelButtonMsg}</div>
                        </div>
                    </div>}
                    { props.rescheduleEnabled && <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="rescheduleButton"
                                className="theme-btn-reschedule w-full"
                                data-testid="reschedule-button"
                                onClick={onReschedule}
                                disabled={!props.rescheduleEnabled}
                                aria-labelledby="rescheduleMsg rescheduleButton"
                            >{globalCtx.LangResources.recruitMsg.rescheduleButton ?? "Reschedule"}</Button>
                            <div id="rescheduleMsg" className="text-center text-sm pb-2">{globalCtx.LangResources.recruitMsg.rescheduleButtonMsg}</div>
                        </div>
                    </div>}
                    {(props.cancelEnabled || props.rescheduleEnabled) &&<div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="skipButton"
                                className="theme-btn-skip w-full"
                                data-testid="skip-button"
                                onClick={onSkip}
                                aria-labelledby="skipMsg skipButton"
                            >{globalCtx.LangResources.recruitMsg.skipButton ?? "Skip"}</Button>
                            <div id="skipMsg" className="text-center text-sm">{globalCtx.LangResources.recruitMsg.skipButtonMsg}</div>
                        </div>
                    </div>}
                </div>
            }
            {/* PostSurvey Cancel */}
            {(recruitCtx.currentState === ScheduleState.POST_SURVEY_CANCEL) &&
                <div className={'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'}>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="cancelButton"
                                className="theme-btn-cancel w-full"
                                data-testid="cancel-button"
                                onClick={onCancel}
                                aria-labelledby="cancelMsg cancelButton"
                            >{globalCtx.LangResources.recruitMsg.cancelConfirmButton ?? "Confirm"}</Button>
                            <div id="cancelMsg" className="text-center text-sm pb-2">{globalCtx.LangResources.recruitMsg.cancelConfirmButtonMsg??"I want to confirm my cancellation"}</div>
                        </div>
                    </div>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="rescheduleButton"
                                className="theme-btn-reschedule w-full"
                                data-testid="reschedule-button"
                                onClick={onReschedule}
                                aria-labelledby="rescheduleMsg rescheduleButton"
                            >{globalCtx.LangResources.recruitMsg.rescheduleButton ?? "Reschedule"}</Button>
                            <div id="rescheduleMsg" className="text-center text-sm pb-2">{globalCtx.LangResources.recruitMsg.rescheduleButtonMsg}</div>
                        </div>
                    </div>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="skipButton"
                                className="theme-btn-skip w-full"
                                data-testid="skip-button"
                                onClick={onSkip}
                                aria-labelledby="skipMsg skipButton"
                            >{globalCtx.LangResources.recruitMsg.skipButton ?? "Skip"}</Button>
                            <div id="skipMsg" className="text-center text-sm">{globalCtx.LangResources.recruitMsg.skipButtonMsg}</div>
                        </div>
                    </div>
                </div>
            }
            {/* PostSurvey Reschedule Confirm */}
            {recruitCtx.currentState === ScheduleState.POST_SURVEY_RESCHEDULE_CONFIRM &&
                <div className={'theme-btn-container min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'}>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="scheduleButton"
                                ref={buttonRef}
                                className="theme-btn-schedule w-full"
                                data-testid="schedule-btn"
                                onClick={onPostSurveyConfirm}
                                aria-labelledby={`${confirmLabels} scheduleButton`}
                            >
                                {globalCtx.LangResources.recruitMsg.scheduleButton}
                            </Button>
                            <Label id="scheduleMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.scheduleButtonMsg}</Label>
                        </div>
                    </div>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="skipButton"
                                className="theme-btn-skip w-full"
                                data-testid="skip-button"
                                onClick={onSkip}
                                aria-labelledby="skipMsg skipButton"
                            >{globalCtx.LangResources.recruitMsg.skipButton ?? "Skip"}</Button>
                            <div id="skipMsg" className="text-center text-sm">{globalCtx.LangResources.recruitMsg.skipButtonMsg}</div>
                        </div>
                    </div>
                    <div className="md:basis-1 lg:basis-1/3 lg:px-4">
                        <div className="flex flex-col">
                            <Button
                                id="backButton"
                                className="theme-btn-previous w-full"
                                data-testid="back-button"
                                onClick={onBack}
                                aria-labelledby="backMsg backButton"
                            >{globalCtx.LangResources.recruitMsg.backButton ?? "Back"}</Button>
                            <div id="backMsg" className="text-center text-sm pt-2">{globalCtx.LangResources.recruitMsg.backButtonMsg}</div>
                        </div>
                    </div>
                </div>
            }
            <GetScheduleRestrictionMsg/>
        </div>
    )
}